import { OrganizationMember } from "@common/dto/organization/organization-member.dto";
import { useUser } from "@hooks/useUser";
import { canManageTeamMember } from "@common/helpers/permissions/organizationPermissions";
import { useWorkspacesList } from "@api/workspace.api";
import { useActiveOrganizationRole } from "./useActiveOrganizationRole";

export function useCanManageOrganizationMember(
    memberToManage: OrganizationMember,
) {
    const role = useActiveOrganizationRole();
    const user = useUser();
    const workspacesQuery = useWorkspacesList();

    if (!role || !user || !workspacesQuery?.data) {
        return false;
    }

    return canManageTeamMember({
        actingUser: {
            id: user.id,
            role,
            workspaceAssignments: workspacesQuery.data.map((w) => w.id),
        },
        managedUser: {
            id: memberToManage.user.id,
            role: memberToManage.role,
            workspaceAssignments: memberToManage.workspaceAssignments.map(
                (assignment) => assignment.workspaceId,
            ),
        },
    });
}
